import {
    RESET_RISK,
    UPDATE_RISK_CONFIG,
    UPDATE_RISK_CONFIG_FAIL,
    UPDATE_RISK_CONFIG_SUCCESS
} from './actionTypes';

const initialState = {
    riskToUpdate: {},
    updatedRisk: {},
    error: null,
    loading: false,
    loaded: false
};

export function updateRiskReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_RISK_CONFIG: {
            return {
                ...initialState,
                riskToUpdate: action.payload.config,
                loading: true,
                loaded: false
            };
        }
        case UPDATE_RISK_CONFIG_SUCCESS:
            return {
                ...state,
                updatedRisk: action.payload,
                loaded: true,
                loading: false
            };
        case UPDATE_RISK_CONFIG_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        case RESET_RISK: {
            return initialState;
        }
        default:
            return state;
    }
}
